import _ from 'underscore';
import { useCallback, useState } from 'react';
import { Genders } from './consts';

const DefaultGenders = _.keys(Genders);

const mapGenderCriterionsToViewModel = criterions =>
  _.map(criterions, ({ Criterion }) => Criterion.GenderType);

const mapGenderToBulkModel = (gender, campaignId, status, id) => ({
  Campaign: { Id: campaignId },
  Status: status,
  CriterionType: 'Gender',
  Criterion: {
    Type: 'Gender',
    GenderCriterion: {
      Target: gender,
    },
  },
  ...(status === 'Deleted' && { Id: id }),
});

export const useTargetingGenderAdapter = ({
  campaignId,
}) => {
  const [initialCriterions, setInitialCriterions] = useState([]);

  const mapToViewModel = useCallback((criterions) => {
    setInitialCriterions(criterions);

    const initialTargets = mapGenderCriterionsToViewModel(criterions);
    return !_.isEmpty(initialTargets) ? initialTargets : DefaultGenders;
  }, []);

  const mapToBulkModel = useCallback((newGenders) => {
    const gendersBefore = mapGenderCriterionsToViewModel(initialCriterions);
    const gendersAfter = newGenders;

    const gendersToAdd = _.difference(gendersAfter, gendersBefore);
    const gendersToDelete = _.difference(gendersBefore, gendersAfter);

    const targetsToAdd = _.chain(newGenders)
      .filter(gender => gendersToAdd.includes(gender))
      .map(gender => mapGenderToBulkModel(gender, campaignId, 'Active'))
      .value();

    const targetsToDelete = _.chain(initialCriterions)
      .filter(criterion => gendersToDelete.includes(criterion.Criterion.GenderType))
      .map(criterion => mapGenderToBulkModel(criterion.Criterion.GenderType, campaignId, 'Deleted', criterion.Id))
      .value();

    return _.union(targetsToAdd, targetsToDelete);
  }, [campaignId, initialCriterions]);

  return {
    mapToViewModel,
    mapToBulkModel,
  };
};
